import { create } from 'zustand';

interface StoreState {
    attempts: number;
    depositUniqueReference: string;
    fileReference: Record<string, { dur: string; ur: string }>;
    isUploadingFile: boolean;
    setAttempts: (attempts: number) => void;
    setFileReference: (
        fileName: string,
        fileReference: { dur: string; ur: string }
    ) => void;
    setDepositUniqueReference: (depositUniqueReference: string) => void;
    setIsUploadingFile: (isUploadingFile: boolean) => void;
    setShouldClaimToken: (shouldClaimToken: boolean) => void;
    setSpectreAgentUrl: (spectreAgentUrl: string) => void;
    setSpectreControlUrl: (spectreControlUrl: string) => void;
    setVaultToken: (vaultToken: string) => void;
    shouldClaimToken?: boolean;
    spectreAgentUrl?: string;
    spectreControlUrl?: string;
    vaultToken: string;
    spectreRequestToken: string;
    setSpectreRequestToken: (spectreRequestToken: string) => void;
    continueUpload?: boolean;
    setContinueUpload?: (continueUpload: boolean) => void;
}

const useDepositNowStore = create<StoreState>()((set) => ({
    attempts: 0,
    continueUpload: true,
    depositUniqueReference: '',
    fileReference: {},
    setFileReference: (fileName, fileReference: { dur: string; ur: string }) =>
        set((state) => ({
            fileReference: {
                ...state.fileReference,
                [fileName]: fileReference
            }
        })),
    isUploadingFile: false,
    setAttempts: (attempts: number) => set({ attempts }),
    setContinueUpload: (continueUpload: boolean) => set({ continueUpload }),
    setDepositUniqueReference: (depositUniqueReference: string) =>
        set({ depositUniqueReference }),
    setIsUploadingFile: (isUploadingFile: boolean) => set({ isUploadingFile }),
    setShouldClaimToken: (shouldClaimToken: boolean) =>
        set({ shouldClaimToken }),
    setSpectreAgentUrl: (spectreAgentUrl: string) => set({ spectreAgentUrl }),
    setSpectreControlUrl: (spectreControlUrl: string) =>
        set({ spectreControlUrl }),
    setVaultToken: (vaultToken: string) => set({ vaultToken: vaultToken }),
    shouldClaimToken: false,
    vaultToken: '',
    spectreRequestToken: '',
    setSpectreRequestToken: (spectreRequestToken: string) =>
        set({ spectreRequestToken: spectreRequestToken })
}));

export const getContinueUpload = (): boolean => {
    return useDepositNowStore.getState().continueUpload ?? true;
};

export const getFileReference = (
    fileName: string
): { dur: string; ur: string } => {
    return useDepositNowStore.getState().fileReference[fileName];
};

export const getIsUploadingFile = (): boolean => {
    return useDepositNowStore.getState().isUploadingFile;
};

export const getToken = (): string => {
    return useDepositNowStore.getState().spectreRequestToken;
};

export const getVaultToken = (): string => {
    return useDepositNowStore.getState().vaultToken;
};

export const setContinueUpload = (continueUpload: boolean): void => {
    useDepositNowStore.setState({ continueUpload });
};

export const setIsUploadingFile = (uploading: boolean): void => {
    useDepositNowStore.setState({ isUploadingFile: uploading });
};

export const setVaultToken = (token: string): void => {
    useDepositNowStore.setState({ vaultToken: token });
};

export default useDepositNowStore;
